import { omit } from 'lodash';
import { ExportDocumentSection } from '../export-task.interfaces';
import { ExportPropertyTypeTransformParams } from '../processors/types/processor-types.interface';
import { ExportFileFormat } from '../export-task.enum';

/** @internal Do not use directly */
export class JSONGenerator {
  constructor(private sections: ExportDocumentSection[]) { }

  generateObject() {
    const root: Record<string, any> = {};
    this.sections.forEach((section) => {
      if (section.name === '' || section.name === null) {
        root['__rows'] = [
          ...(root['__rows'] || []),
          ...section.list,
        ];
      } else {
        root[section.name] = [...section.list];
      }
    });
    if (Object.keys(root).length === 1 && root['__rows']) {
      return { rows: root['__rows'] };
    }
    if (!root['rows'] && root['__rows']) {
      return {
        ...omit(root, '__rows'),
        rows: root['__rows'],
      };
    }
    return root;
  }

  private transformObjectPropertiesRecursively(target: any) {
    Object.entries(target).forEach(([key, value]) => {
      if (value && typeof value === 'object') {
        if ((value as any).__for_processor) {
          const tparams = value as ExportPropertyTypeTransformParams;
          if (tparams.formats.includes(ExportFileFormat.JSON)) {
            target[key] = tparams.transform() || tparams.fallback;
          } else {
            target[key] = tparams.fallback;
          }
        } else {
          this.transformObjectPropertiesRecursively(value);
        }
      }
    });
  }

  generate() {
    const generated = this.generateObject();
    this.transformObjectPropertiesRecursively(generated)
    return JSON.stringify(generated);
  }
}
